<geaui-page-layout
  [headerTemplate]="header"
  [contentTemplate]="content"
  [sidebarTemplate]="sidebar"
>
  <ng-template #header>
    <div class="header">
      <geaui-header [noAuth]="false" [headerTitle]="title"></geaui-header>
    </div>
  </ng-template>
  <ng-template #content>
    @if (isRefactored) {
      @if (tokenReady && userReady && configReady) {
        <div
          class="refactor-content-body gea-width-desktop gea-width-desktop-sm"
        >
          <router-outlet></router-outlet>
        </div>
      }
    } @else {
      <hrt-loader
        [setLoader]="!(tokenReady && userReady) || showLoadingIcon"
        [loadingMessage]="loadingMessage"
      ></hrt-loader>
      <div
        class="content-body"
        [style.width]="'calc(' + setContentWidth() + ')'"
        *ngIf="tokenReady && userReady && configReady"
      >
        <router-outlet></router-outlet>
      </div>
    }
  </ng-template>
  <ng-template #sidebar>
    @if (tokenReady && userReady) {
      <geaui-sidebar-v2
        [devisionIconPath]="divisionIconUrl"
        [devisionName]="'HRT Connect'"
        [navigationItems]="items"
        [bottomNavigation]="navItems"
        [hasSearch]="false"
        [slimView]="true"
        [bottomNavigation]="bottomNavItems"
      ></geaui-sidebar-v2>
    }
  </ng-template>
</geaui-page-layout>
